import React from 'react';
import { Modal,Button } from '@ezviz/ezd';
import ConnectUs from '../ContactUs';

class ContactUsModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      title: "期待与您的合作",
      appKey: "11111111111111111111111111111111",
      step: 0
    };
  }
  componentDidMount(){
    this.setState({
      step: 0
    });
  }
  componentWillUnmount(){
    clearTimeout(this.timer);
  }
  showModal = key => (e) => {
    e.preventDefault(); // 修复 Android 上点击穿透
    this.setState({
      title: "期待与您的合作",
      appKey: "11111111111111111111111111111111",
      modal: true,
    });
    window.monitor && window.monitor.report({textKey: `website_fixbar_${this.props.ptype}`, text: this.props.title});
  }
  onClose = key => () => {
    this.setState({
      modal: false,
      step: 0
    });
  }
  onRef = (ref) => {
    this.child = ref
  }
  click = (e) => {
    this.child.handleSubmit();
    // this.setState({
    //   step:this.child.state.step
    // })
  }
  onChange = (e) => {
    this.setState({
        step: 1
      })
  }

  render() {
    const { props, width=480, height=648, simpleDescription } = this.props;
    const { title, appKey, step } = this.state;
    return (
      <div className="ContactUsModal-wrap">
        { this.props.text ?
        <div className={this.props.className} onClick={this.showModal()}>{this.props.text}</div>
        :
        <div onClick={this.showModal()}>
          {this.props.children}
        </div>
        }
        <Modal
          closeIcon = {
            <img src="https://resource.eziot.com/group2/M00/00/01/CtwQFl77BpmAfQsUAAACLpgJ95U706.png" style={{width:16}} />
          }
          title={this.state.title}
          visible={this.state.modal}
          destroyOnClose
          transparent
          centered
          width={width}
          closable
          maskClosable={false}
          getContainer={this.props.parentNode}
          footer={step==1 ? null: <div style={{marginBottom: 24}}>
            <Button onClick={this.onClose()}>取消</Button>
            <Button type='primary' onClick={this.click}>联系我们</Button>
          </div>}
          okText="联系我们"
          cancelText="取消"
          onOk={this.click}
          onCancel={this.onClose()}
          onClose={this.onClose()}
          afterClose={() => { }}
        >
          <ConnectUs theme="white mobile" subTitle="留下您的联系方式，我们会第一时间与您联系" onChange={this.onChange} onRef={this.onRef} onOK={this.onClose()} appKey={appKey}  simpleDescription={simpleDescription}/>
        </Modal>
        </div>
      )
    }
}
export default ContactUsModal;
